import * as React from 'react';

var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "motorway-svg-stroke",
    stroke: "#bcbcbb",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2,
    cx: 6,
    cy: 6,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "motorway-svg-fill",
    d: "M10.88 9.5L9.7 10.6l3.76 4.03a.8.8 0 101.17-1.09l-3.76-4.03z",
    fill: "#bcbcbb"
  }))));
}

export { SvgSearch as S };
